module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kollegan":"Your colleague","har kommenterat på talangen":"has commented on the candidate","i jobbet":"in the job"},"sv":{"Kollegan":"Din kollegan","har kommenterat på talangen":"har kommenterat på kandidaten","i jobbet":"i jobbet"}}')
  delete Component.options._Ctor
}
